import { render, staticRenderFns } from "./AppNavigationHeaderDatePicker.vue?vue&type=template&id=e8250812&"
import script from "./AppNavigationHeaderDatePicker.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8250812')) {
      api.createRecord('e8250812', component.options)
    } else {
      api.reload('e8250812', component.options)
    }
    module.hot.accept("./AppNavigationHeaderDatePicker.vue?vue&type=template&id=e8250812&", function () {
      api.rerender('e8250812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/AppNavigationHeader/AppNavigationHeaderDatePicker.vue"
export default component.exports